<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Budget/components/Available'

    export default {
        components: {
            Grid,
        }
    }
</script>